import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Logger, LoggingService } from 'ionic-logging-service';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { EventService } from '../events/event.service';
import { StorageService } from '../storage/storage.service';
import { TenantService } from '../tenant/tenant.service';
import { UserService } from '../user/user.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  private logger: Logger;
  private storedItemKeys = ['lastUsedTenant', 'idpLoginToken'];

  constructor(
    private eventService: EventService,
    private loggingService: LoggingService,
    public navController: NavController,
    private storageService: StorageService,
    private tenantService: TenantService,
    private userService: UserService
  ) {
    this.logger = loggingService.getLogger("[LogoutService]");
    const methodName = "ctor";
    this.logger.entry(methodName);
  }

  public signOutUser(): Observable<void> {
    this.logger.info('signOutUser()');
    return this.storageService.removeStoredItems(this.storedItemKeys).pipe(
      take(1),
      switchMap(() => this.userService.resetUser()),
      switchMap(() => this.tenantService.resetTenant()),
      switchMap(() => this.eventService.resetPusher()),
      catchError(err => {
        this.logger.error('signOutUser() chain error: ' + JSON.stringify(err));
        return of(err); // or throwError(err) if you want to propagate
      }),
      map(() => void 0),
    );
  }
}